import React from 'react';
import { History, SquarePen, ChevronLeft, MessageSquare, ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/core/utils';

interface MobileChatHeaderProps {
  currentView: 'chat' | 'history';
  onViewChange: (view: 'chat' | 'history') => void;
  onNewChat: () => void;
  onClose: () => void;
  className?: string;
}

/**
 * Header component for mobile AI chat overlay.
 * Contains chat/history toggle, close button, and new chat button.
 */
export const MobileChatHeader: React.FC<MobileChatHeaderProps> = ({
  currentView,
  onViewChange,
  onNewChat,
  onClose,
  className,
}) => {
  return (
    <header className={cn(
      'flex items-center justify-between px-4 py-2 border-b shrink-0',
      className
    )}>
      {currentView === 'history' ? (
        <>
          <Button
            variant="ghost"
            size="icon"
            className="h-9 w-9"
            onClick={() => onViewChange('chat')}
          >
            <ChevronLeft className="h-5 w-5" />
          </Button>
          <span className="text-base font-medium">History</span>
          <Button
            variant="ghost"
            size="icon"
            className="h-9 w-9"
            onClick={onClose}
          >
            <ChevronDown className="h-5 w-5" />
          </Button>
        </>
      ) : (
        <>
          <Button
            variant="ghost"
            size="icon"
            className="h-9 w-9"
            onClick={() => onViewChange('history')}
          >
            <History className="h-5 w-5" />
          </Button>
          <div className="flex-1" />
          <div className="flex items-center gap-1">
            <Button
              variant="ghost"
              size="icon"
              className="h-9 w-9"
              onClick={onNewChat}
            >
              <SquarePen className="h-5 w-5" />
            </Button>
            <Button
              variant="ghost"
              size="icon"
              className="h-9 w-9"
              onClick={onClose}
            >
              <ChevronDown className="h-5 w-5" />
            </Button>
          </div>
        </>
      )}
    </header>
  );
};
